/*!
 * vue-i18n v9.2.0-beta.26
 * (c) 2021 kazuya kawaguchi
 * Released under the MIT License.
 */
var VueI18n = (function (e, t) {
  "use strict";
  const n =
      "function" == typeof Symbol && "symbol" == typeof Symbol.toStringTag,
    r = (e) => (n ? Symbol(e) : e),
    a = (e) =>
      JSON.stringify(e)
        .replace(/\u2028/g, "\\u2028")
        .replace(/\u2029/g, "\\u2029")
        .replace(/\u0027/g, "\\u0027"),
    o = (e) => "number" == typeof e && isFinite(e),
    s = (e) => "[object RegExp]" === k(e),
    l = (e) => v(e) && 0 === Object.keys(e).length;
  function c(e, t) {
    "undefined" != typeof console &&
      (console.warn("[intlify] " + e), t && console.warn(t.stack));
  }
  const i = Object.assign;
  function u(e) {
    return e
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&apos;");
  }
  const f = Object.prototype.hasOwnProperty;
  function m(e, t) {
    return f.call(e, t);
  }
  const p = Array.isArray,
    g = (e) => "function" == typeof e,
    d = (e) => "string" == typeof e,
    _ = (e) => "boolean" == typeof e,
    b = (e) => null !== e && "object" == typeof e,
    h = Object.prototype.toString,
    k = (e) => h.call(e),
    v = (e) => "[object Object]" === k(e),
    y = 15;
  function L(e, t, n = {}) {
    const { domain: r, messages: a, args: o } = n,
      s = new SyntaxError(String(e));
    return (s.code = e), t && (s.location = t), (s.domain = r), s;
  }
  function T(e) {
    throw e;
  }
  function E(e, t, n) {
    const r = { start: e, end: t };
    return null != n && (r.source = n), r;
  }
  const F = " ",
    N = "\n",
    I = String.fromCharCode(8232),
    R = String.fromCharCode(8233);
  function O(e) {
    const t = e;
    let n = 0,
      r = 1,
      a = 1,
      o = 0;
    const s = (e) => "\r" === t[e] && t[e + 1] === N,
      l = (e) => t[e] === R,
      c = (e) => t[e] === I,
      i = (e) => s(e) || ((e) => t[e] === N)(e) || l(e) || c(e),
      u = (e) => (s(e) || l(e) || c(e) ? N : t[e]);
    function f() {
      return (o = 0), i(n) && (r++, (a = 0)), s(n) && n++, n++, a++, t[n];
    }
    return {
      index: () => n,
      line: () => r,
      column: () => a,
      peekOffset: () => o,
      charAt: u,
      currentChar: () => u(n),
      currentPeek: () => u(n + o),
      next: f,
      peek: function () {
        return s(n + o) && o++, o++, t[n + o];
      },
      reset: function () {
        (n = 0), (r = 1), (a = 1), (o = 0);
      },
      resetPeek: function (e = 0) {
        o = e;
      },
      skipToPeek: function () {
        const e = n + o;
        for (; e !== n; ) f();
        o = 0;
      },
    };
  }
  const C = void 0;
  function P(e, t = {}) {
    const n = !1 !== t.location,
      r = O(e),
      a = () => r.index(),
      o = () => {
        return (
          (e = r.line()),
          (t = r.column()),
          (n = r.index()),
          { line: e, column: t, offset: n }
        );
        var e, t, n;
      },
      s = o(),
      l = a(),
      c = {
        currentType: 14,
        offset: l,
        startLoc: s,
        endLoc: s,
        lastType: 14,
        lastOffset: l,
        lastStartLoc: s,
        lastEndLoc: s,
        braceNest: 0,
        inLinked: !1,
        text: "",
      },
      i = () => c,
      { onError: u } = t;
    function f(e, t, r) {
      (e.endLoc = o()), (e.currentType = t);
      const a = { type: t };
      return (
        n && (a.loc = E(e.startLoc, e.endLoc)), null != r && (a.value = r), a
      );
    }
    const m = (e) => f(e, 14);
    function p(e, t) {
      return e.currentChar() === t ? (e.next(), t) : (o(), "");
    }
    function g(e) {
      let t = "";
      for (; e.currentPeek() === F || e.currentPeek() === N; )
        (t += e.currentPeek()), e.peek();
      return t;
    }
    function d(e) {
      const t = g(e);
      return e.skipToPeek(), t;
    }
    function _(e) {
      if (e === C) return !1;
      const t = e.charCodeAt(0);
      return (t >= 97 && t <= 122) || (t >= 65 && t <= 90) || 95 === t;
    }
    function b(e, t) {
      const { currentType: n } = t;
      if (2 !== n) return !1;
      g(e);
      const r = (function (e) {
        if (e === C) return !1;
        const t = e.charCodeAt(0);
        return t >= 48 && t <= 57;
      })("-" === e.currentPeek() ? e.peek() : e.currentPeek());
      return e.resetPeek(), r;
    }
    function h(e) {
      g(e);
      const t = "|" === e.currentPeek();
      return e.resetPeek(), t;
    }
    function k(e, t = !0) {
      const n = (t = !1, r = "", a = !1) => {
          const o = e.currentPeek();
          return "{" === o
            ? "%" !== r && t
            : "@" !== o && o
            ? "%" === o
              ? (e.peek(), n(t, "%", !0))
              : "|" === o
              ? !("%" !== r && !a) || !(r === F || r === N)
              : o === F
              ? (e.peek(), n(!0, F, a))
              : o !== N || (e.peek(), n(!0, N, a))
            : "%" === r || t;
        },
        r = n();
      return t && e.resetPeek(), r;
    }
    function v(e, t) {
      const n = e.currentChar();
      return n === C ? C : t(n) ? (e.next(), n) : null;
    }
    function y(e) {
      return v(e, (e) => {
        const t = e.charCodeAt(0);
        return (
          (t >= 97 && t <= 122) ||
          (t >= 65 && t <= 90) ||
          (t >= 48 && t <= 57) ||
          95 === t ||
          36 === t
        );
      });
    }
    function L(e) {
      return v(e, (e) => {
        const t = e.charCodeAt(0);
        return t >= 48 && t <= 57;
      });
    }
    function T(e) {
      return v(e, (e) => {
        const t = e.charCodeAt(0);
        return (
          (t >= 48 && t <= 57) || (t >= 65 && t <= 70) || (t >= 97 && t <= 102)
        );
      });
    }
    function I(e) {
      let t = "",
        n = "";
      for (; (t = L(e)); ) n += t;
      return n;
    }
    function R(e) {
      const t = e.currentChar();
      switch (t) {
        case "\\":
        case "'":
          return e.next(), `\\${t}`;
        case "u":
          return P(e, t, 4);
        case "U":
          return P(e, t, 6);
        default:
          return o(), "";
      }
    }
    function P(e, t, n) {
      p(e, t);
      let r = "";
      for (let t = 0; t < n; t++) {
        const t = T(e);
        if (!t) {
          o(), e.currentChar();
          break;
        }
        r += t;
      }
      return `\\${t}${r}`;
    }
    function w(e) {
      d(e);
      const t = p(e, "|");
      return d(e), t;
    }
    function M(e, t) {
      let n = null;
      switch (e.currentChar()) {
        case "{":
          return (
            t.braceNest >= 1 && o(),
            e.next(),
            (n = f(t, 2, "{")),
            d(e),
            t.braceNest++,
            n
          );
        case "}":
          return (
            t.braceNest > 0 && 2 === t.currentType && o(),
            e.next(),
            (n = f(t, 3, "}")),
            t.braceNest--,
            t.braceNest > 0 && d(e),
            t.inLinked && 0 === t.braceNest && (t.inLinked = !1),
            n
          );
        case "@":
          return (
            t.braceNest > 0 && o(), (n = W(e, t) || m(t)), (t.braceNest = 0), n
          );
        default:
          let r = !0,
            a = !0,
            s = !0;
          if (h(e))
            return (
              t.braceNest > 0 && o(),
              (n = f(t, 1, w(e))),
              (t.braceNest = 0),
              (t.inLinked = !1),
              n
            );
          if (
            t.braceNest > 0 &&
            (5 === t.currentType || 6 === t.currentType || 7 === t.currentType)
          )
            return o(), (t.braceNest = 0), S(e, t);
          if (
            (r = (function (e, t) {
              const { currentType: n } = t;
              if (2 !== n) return !1;
              g(e);
              const r = _(e.currentPeek());
              return e.resetPeek(), r;
            })(e, t))
          )
            return (
              (n = f(
                t,
                5,
                (function (e) {
                  d(e);
                  let t = "",
                    n = "";
                  for (; (t = y(e)); ) n += t;
                  return e.currentChar() === C && o(), n;
                })(e)
              )),
              d(e),
              n
            );
          if ((a = b(e, t)))
            return (
              (n = f(
                t,
                6,
                (function (e) {
                  d(e);
                  let t = "";
                  return (
                    "-" === e.currentChar()
                      ? (e.next(), (t += `-${I(e)}`))
                      : (t += I(e)),
                    e.currentChar() === C && o(),
                    t
                  );
                })(e)
              )),
              d(e),
              n
            );
          if (
            (s = (function (e, t) {
              const { currentType: n } = t;
              if (2 !== n) return !1;
              g(e);
              const r = "'" === e.currentPeek();
              return e.resetPeek(), r;
            })(e, t))
          )
            return (
              (n = f(
                t,
                7,
                (function (e) {
                  d(e), p(e, "'");
                  let t = "",
                    n = "";
                  const r = (e) => "'" !== e && e !== N;
                  for (; (t = v(e, r)); ) n += "\\" === t ? R(e) : t;
                  const a = e.currentChar();
                  return a === N || a === C
                    ? (o(), a === N && (e.next(), p(e, "'")), n)
                    : (p(e, "'"), n);
                })(e)
              )),
              d(e),
              n
            );
          if (!r && !a && !s)
            return (
              (n = f(
                t,
                13,
                (function (e) {
                  d(e);
                  let t = "",
                    n = "";
                  const r = (e) => "{" !== e && "}" !== e && e !== F && e !== N;
                  for (; (t = v(e, r)); ) n += t;
                  return n;
                })(e)
              )),
              o(),
              n.value,
              d(e),
              n
            );
      }
      return n;
    }
    function W(e, t) {
      const { currentType: n } = t;
      let r = null;
      const a = e.currentChar();
      switch (
        ((8 !== n && 9 !== n && 12 !== n && 10 !== n) ||
          (a !== N && a !== F) ||
          o(),
        a)
      ) {
        case "@":
          return e.next(), (r = f(t, 8, "@")), (t.inLinked = !0), r;
        case ".":
          return d(e), e.next(), f(t, 9, ".");
        case ":":
          return d(e), e.next(), f(t, 10, ":");
        default:
          return h(e)
            ? ((r = f(t, 1, w(e))), (t.braceNest = 0), (t.inLinked = !1), r)
            : (function (e, t) {
                const { currentType: n } = t;
                if (8 !== n) return !1;
                g(e);
                const r = "." === e.currentPeek();
                return e.resetPeek(), r;
              })(e, t) ||
              (function (e, t) {
                const { currentType: n } = t;
                if (8 !== n && 12 !== n) return !1;
                g(e);
                const r = ":" === e.currentPeek();
                return e.resetPeek(), r;
              })(e, t)
            ? (d(e), W(e, t))
            : (function (e, t) {
                const { currentType: n } = t;
                if (9 !== n) return !1;
                g(e);
                const r = _(e.currentPeek());
                return e.resetPeek(), r;
              })(e, t)
            ? (d(e),
              f(
                t,
                12,
                (function (e) {
                  let t = "",
                    n = "";
                  for (; (t = y(e)); ) n += t;
                  return n;
                })(e)
              ))
            : (function (e, t) {
                const { currentType: n } = t;
                if (10 !== n) return !1;
                const r = () => {
                    const t = e.currentPeek();
                    return "{" === t
                      ? _(e.peek())
                      : !(
                          "@" === t ||
                          "%" === t ||
                          "|" === t ||
                          ":" === t ||
                          "." === t ||
                          t === F ||
                          !t
                        ) && (t === N ? (e.peek(), r()) : _(t));
                  },
                  a = r();
                return e.resetPeek(), a;
              })(e, t)
            ? (d(e),
              "{" === a
                ? M(e, t) || r
                : f(
                    t,
                    11,
                    (function (e) {
                      const t = (n = !1, r) => {
                        const a = e.currentChar();
                        return "{" !== a &&
                          "%" !== a &&
                          "@" !== a &&
                          "|" !== a &&
                          a
                          ? a === F
                            ? r
                            : a === N
                            ? ((r += a), e.next(), t(n, r))
                            : ((r += a), e.next(), t(!0, r))
                          : r;
                      };
                      return t(!1, "");
                    })(e)
                  ))
            : (8 === n && o(), (t.braceNest = 0), (t.inLinked = !1), S(e, t));
      }
    }
    function S(e, t) {
      let n = { type: 14 };
      if (t.braceNest > 0) return M(e, t) || m(t);
      if (t.inLinked) return W(e, t) || m(t);
      const r = e.currentChar();
      switch (r) {
        case "{":
          return M(e, t) || m(t);
        case "}":
          return o(), e.next(), f(t, 3, "}");
        case "@":
          return W(e, t) || m(t);
        default:
          if (h(e))
            return (n = f(t, 1, w(e))), (t.braceNest = 0), (t.inLinked = !1), n;
          if (k(e))
            return f(
              t,
              0,
              (function (e) {
                let t = "";
                for (;;) {
                  const n = e.currentChar();
                  if ("{" === n || "}" === n || "@" === n || "|" === n || !n)
                    break;
                  if ("%" === n) {
                    if (!k(e)) break;
                    (t += n), e.next();
                  } else if (n === F || n === N)
                    if (k(e)) (t += n), e.next();
                    else {
                      if (h(e)) break;
                      (t += n), e.next();
                    }
                  else (t += n), e.next();
                }
                return t;
              })(e)
            );
          if ("%" === r) return e.next(), f(t, 4, "%");
      }
      return n;
    }
    return {
      nextToken: function () {
        const { currentType: e, offset: t, startLoc: n, endLoc: s } = c;
        return (
          (c.lastType = e),
          (c.lastOffset = t),
          (c.lastStartLoc = n),
          (c.lastEndLoc = s),
          (c.offset = a()),
          (c.startLoc = o()),
          r.currentChar() === C ? f(c, 14) : S(r, c)
        );
      },
      currentOffset: a,
      currentPosition: o,
      context: i,
    };
  }
  const w = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
  function M(e, t, n) {
    switch (e) {
      case "\\\\":
        return "\\";
      case "\\'":
        return "'";
      default: {
        const e = parseInt(t || n, 16);
        return e <= 55295 || e >= 57344 ? String.fromCodePoint(e) : "�";
      }
    }
  }
  function W(e = {}) {
    const t = !1 !== e.location,
      { onError: n } = e;
    function r(e, n, r) {
      const a = { type: e, start: n, end: n };
      return t && (a.loc = { start: r, end: r }), a;
    }
    function a(e, n, r, a) {
      (e.end = n), a && (e.type = a), t && e.loc && (e.loc.end = r);
    }
    function o(e, t) {
      const n = e.context(),
        o = r(3, n.offset, n.startLoc);
      return (o.value = t), a(o, e.currentOffset(), e.currentPosition()), o;
    }
    function s(e, t) {
      const n = e.context(),
        { lastOffset: o, lastStartLoc: s } = n,
        l = r(5, o, s);
      return (
        (l.index = parseInt(t, 10)),
        e.nextToken(),
        a(l, e.currentOffset(), e.currentPosition()),
        l
      );
    }
    function l(e, t) {
      const n = e.context(),
        { lastOffset: o, lastStartLoc: s } = n,
        l = r(4, o, s);
      return (
        (l.key = t),
        e.nextToken(),
        a(l, e.currentOffset(), e.currentPosition()),
        l
      );
    }
    function c(e, t) {
      const n = e.context(),
        { lastOffset: o, lastStartLoc: s } = n,
        l = r(9, o, s);
      return (
        (l.value = t.replace(w, M)),
        e.nextToken(),
        a(l, e.currentOffset(), e.currentPosition()),
        l
      );
    }
    function u(e) {
      const t = e.context(),
        n = r(6, t.offset, t.startLoc);
      let o = e.nextToken();
      if (9 === o.type) {
        const t = (function (e) {
          const t = e.nextToken(),
            n = e.context(),
            { lastOffset: o, lastStartLoc: s } = n,
            l = r(8, o, s);
          return 12 !== t.type
            ? (n.lastStartLoc,
              (l.value = ""),
              a(l, o, s),
              { nextConsumeToken: t, node: l })
            : (null == t.value && (n.lastStartLoc, S(t)),
              (l.value = t.value || ""),
              a(l, e.currentOffset(), e.currentPosition()),
              { node: l });
        })(e);
        (n.modifier = t.node), (o = t.nextConsumeToken || e.nextToken());
      }
      switch (
        (10 !== o.type && (t.lastStartLoc, S(o)),
        (o = e.nextToken()),
        2 === o.type && (o = e.nextToken()),
        o.type)
      ) {
        case 11:
          null == o.value && (t.lastStartLoc, S(o)),
            (n.key = (function (e, t) {
              const n = e.context(),
                o = r(7, n.offset, n.startLoc);
              return (
                (o.value = t), a(o, e.currentOffset(), e.currentPosition()), o
              );
            })(e, o.value || ""));
          break;
        case 5:
          null == o.value && (t.lastStartLoc, S(o)),
            (n.key = l(e, o.value || ""));
          break;
        case 6:
          null == o.value && (t.lastStartLoc, S(o)),
            (n.key = s(e, o.value || ""));
          break;
        case 7:
          null == o.value && (t.lastStartLoc, S(o)),
            (n.key = c(e, o.value || ""));
          break;
        default:
          t.lastStartLoc;
          const i = e.context(),
            u = r(7, i.offset, i.startLoc);
          return (
            (u.value = ""),
            a(u, i.offset, i.startLoc),
            (n.key = u),
            a(n, i.offset, i.startLoc),
            { nextConsumeToken: o, node: n }
          );
      }
      return a(n, e.currentOffset(), e.currentPosition()), { node: n };
    }
    function f(e) {
      const t = e.context(),
        n = r(
          2,
          1 === t.currentType ? e.currentOffset() : t.offset,
          1 === t.currentType ? t.endLoc : t.startLoc
        );
      n.items = [];
      let i = null;
      do {
        const r = i || e.nextToken();
        switch (((i = null), r.type)) {
          case 0:
            null == r.value && (t.lastStartLoc, S(r)),
              n.items.push(o(e, r.value || ""));
            break;
          case 6:
            null == r.value && (t.lastStartLoc, S(r)),
              n.items.push(s(e, r.value || ""));
            break;
          case 5:
            null == r.value && (t.lastStartLoc, S(r)),
              n.items.push(l(e, r.value || ""));
            break;
          case 7:
            null == r.value && (t.lastStartLoc, S(r)),
              n.items.push(c(e, r.value || ""));
            break;
          case 8:
            const a = u(e);
            n.items.push(a.node), (i = a.nextConsumeToken || null);
        }
      } while (14 !== t.currentType && 1 !== t.currentType);
      return (
        a(
          n,
          1 === t.currentType ? t.lastOffset : e.currentOffset(),
          1 === t.currentType ? t.lastEndLoc : e.currentPosition()
        ),
        n
      );
    }
    function m(e) {
      const t = e.context(),
        { offset: n, startLoc: o } = t,
        s = f(e);
      return 14 === t.currentType
        ? s
        : (function (e, t, n, o) {
            const s = e.context();
            let l = 0 === o.items.length;
            const c = r(1, t, n);
            (c.cases = []), c.cases.push(o);
            do {
              const t = f(e);
              l || (l = 0 === t.items.length), c.cases.push(t);
            } while (14 !== s.currentType);
            return a(c, e.currentOffset(), e.currentPosition()), c;
          })(e, n, o, s);
    }
    return {
      parse: function (n) {
        const o = P(n, i({}, e)),
          s = o.context(),
          l = r(0, s.offset, s.startLoc);
        return (
          t && l.loc && (l.loc.source = n),
          (l.body = m(o)),
          14 !== s.currentType && (s.lastStartLoc, n[s.offset]),
          a(l, o.currentOffset(), o.currentPosition()),
          l
        );
      },
    };
  }
  function S(e) {
    if (14 === e.type) return "EOF";
    const t = (e.value || "").replace(/\r?\n/gu, "\\n");
    return t.length > 10 ? t.slice(0, 9) + "…" : t;
  }
  function x(e, t) {
    for (let n = 0; n < e.length; n++) D(e[n], t);
  }
  function D(e, t) {
    switch (e.type) {
      case 1:
        x(e.cases, t), t.helper("plural");
        break;
      case 2:
        x(e.items, t);
        break;
      case 6:
        D(e.key, t), t.helper("linked");
        break;
      case 5:
        t.helper("interpolate"), t.helper("list");
        break;
      case 4:
        t.helper("interpolate"), t.helper("named");
    }
  }
  function $(e, t = {}) {
    const n = (function (e, t = {}) {
      const n = { ast: e, helpers: new Set() };
      return { context: () => n, helper: (e) => (n.helpers.add(e), e) };
    })(e);
    n.helper("normalize"), e.body && D(e.body, n);
    const r = n.context();
    e.helpers = Array.from(r.helpers);
  }
  function A(e, t) {
    const { helper: n } = e;
    switch (t.type) {
      case 0:
        !(function (e, t) {
          t.body ? A(e, t.body) : e.push("null");
        })(e, t);
        break;
      case 1:
        !(function (e, t) {
          const { helper: n, needIndent: r } = e;
          if (t.cases.length > 1) {
            e.push(`${n("plural")}([`), e.indent(r());
            const a = t.cases.length;
            for (let n = 0; n < a && (A(e, t.cases[n]), n !== a - 1); n++)
              e.push(", ");
            e.deindent(r()), e.push("])");
          }
        })(e, t);
        break;
      case 2:
        !(function (e, t) {
          const { helper: n, needIndent: r } = e;
          e.push(`${n("normalize")}([`), e.indent(r());
          const a = t.items.length;
          for (let n = 0; n < a && (A(e, t.items[n]), n !== a - 1); n++)
            e.push(", ");
          e.deindent(r()), e.push("])");
        })(e, t);
        break;
      case 6:
        !(function (e, t) {
          const { helper: n } = e;
          e.push(`${n("linked")}(`),
            A(e, t.key),
            t.modifier && (e.push(", "), A(e, t.modifier)),
            e.push(")");
        })(e, t);
        break;
      case 8:
      case 7:
      case 9:
      case 3:
        e.push(JSON.stringify(t.value), t);
        break;
      case 5:
        e.push(`${n("interpolate")}(${n("list")}(${t.index}))`, t);
        break;
      case 4:
        e.push(
          `${n("interpolate")}(${n("named")}(${JSON.stringify(t.key)}))`,
          t
        );
    }
  }
  function U(e, t = {}) {
    const n = i({}, t),
      r = W(n).parse(e);
    return (
      $(r, n),
      ((e, t = {}) => {
        const n = d(t.mode) ? t.mode : "normal",
          r = d(t.filename) ? t.filename : "message.intl",
          a = !!t.sourceMap,
          o =
            null != t.breakLineCode
              ? t.breakLineCode
              : "arrow" === n
              ? ";"
              : "\n",
          s = t.needIndent ? t.needIndent : "arrow" !== n,
          l = e.helpers || [],
          c = (function (e, t) {
            const {
                sourceMap: n,
                filename: r,
                breakLineCode: a,
                needIndent: o,
              } = t,
              s = {
                source: e.loc.source,
                filename: r,
                code: "",
                column: 1,
                line: 1,
                offset: 0,
                map: void 0,
                breakLineCode: a,
                needIndent: o,
                indentLevel: 0,
              };
            function l(e, t) {
              s.code += e;
            }
            function c(e, t = !0) {
              const n = t ? a : "";
              l(o ? n + "  ".repeat(e) : n);
            }
            return {
              context: () => s,
              push: l,
              indent: function (e = !0) {
                const t = ++s.indentLevel;
                e && c(t);
              },
              deindent: function (e = !0) {
                const t = --s.indentLevel;
                e && c(t);
              },
              newline: function () {
                c(s.indentLevel);
              },
              helper: (e) => `_${e}`,
              needIndent: () => s.needIndent,
            };
          })(e, {
            mode: n,
            filename: r,
            sourceMap: a,
            breakLineCode: o,
            needIndent: s,
          });
        c.push("normal" === n ? "function __msg__ (ctx) {" : "(ctx) => {"),
          c.indent(s),
          l.length > 0 &&
            (c.push(
              `const { ${l.map((e) => `${e}: _${e}`).join(", ")} } = ctx`
            ),
            c.newline()),
          c.push("return "),
          A(c, e),
          c.deindent(s),
          c.push("}");
        const { code: i, map: u } = c.context();
        return { ast: e, code: i, map: u ? u.toJSON() : void 0 };
      })(r, n)
    );
  }
  const j = [];
  (j[0] = { w: [0], i: [3, 0], "[": [4], o: [7] }),
    (j[1] = { w: [1], ".": [2], "[": [4], o: [7] }),
    (j[2] = { w: [2], i: [3, 0], 0: [3, 0] }),
    (j[3] = {
      i: [3, 0],
      0: [3, 0],
      w: [1, 1],
      ".": [2, 1],
      "[": [4, 1],
      o: [7, 1],
    }),
    (j[4] = {
      "'": [5, 0],
      '"': [6, 0],
      "[": [4, 2],
      "]": [1, 3],
      o: 8,
      l: [4, 0],
    }),
    (j[5] = { "'": [4, 0], o: 8, l: [5, 0] }),
    (j[6] = { '"': [4, 0], o: 8, l: [6, 0] });
  const H = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
  function V(e) {
    if (null == e) return "o";
    switch (e.charCodeAt(0)) {
      case 91:
      case 93:
      case 46:
      case 34:
      case 39:
        return e;
      case 95:
      case 36:
      case 45:
        return "i";
      case 9:
      case 10:
      case 13:
      case 160:
      case 65279:
      case 8232:
      case 8233:
        return "w";
    }
    return "i";
  }
  function G(e) {
    const t = e.trim();
    return (
      ("0" !== e.charAt(0) || !isNaN(parseInt(e))) &&
      ((n = t),
      H.test(n)
        ? (function (e) {
            const t = e.charCodeAt(0);
            return t !== e.charCodeAt(e.length - 1) || (34 !== t && 39 !== t)
              ? e
              : e.slice(1, -1);
          })(t)
        : "*" + t)
    );
    var n;
  }
  const z = new Map();
  function J(e, t) {
    return b(e) ? e[t] : null;
  }
  const X = (e) => e,
    B = (e) => "",
    Y = (e) => (0 === e.length ? "" : e.join("")),
    q = (e) =>
      null == e
        ? ""
        : p(e) || (v(e) && e.toString === h)
        ? JSON.stringify(e, null, 2)
        : String(e);
  function K(e, t) {
    return (
      (e = Math.abs(e)),
      2 === t ? (e ? (e > 1 ? 1 : 0) : 1) : e ? Math.min(e, 2) : 0
    );
  }
  function Q(e = {}) {
    const t = e.locale,
      n = (function (e) {
        const t = o(e.pluralIndex) ? e.pluralIndex : -1;
        return e.named && (o(e.named.count) || o(e.named.n))
          ? o(e.named.count)
            ? e.named.count
            : o(e.named.n)
            ? e.named.n
            : t
          : t;
      })(e),
      r =
        b(e.pluralRules) && d(t) && g(e.pluralRules[t]) ? e.pluralRules[t] : K,
      a = b(e.pluralRules) && d(t) && g(e.pluralRules[t]) ? K : void 0,
      s = e.list || [],
      l = e.named || {};
    o(e.pluralIndex) &&
      (function (e, t) {
        t.count || (t.count = e), t.n || (t.n = e);
      })(n, l);
    function c(t) {
      const n = g(e.messages)
        ? e.messages(t)
        : !!b(e.messages) && e.messages[t];
      return n || (e.parent ? e.parent.message(t) : B);
    }
    const i =
        v(e.processor) && g(e.processor.normalize) ? e.processor.normalize : Y,
      u =
        v(e.processor) && g(e.processor.interpolate)
          ? e.processor.interpolate
          : q,
      f = {
        list: (e) => s[e],
        named: (e) => l[e],
        plural: (e) => e[r(n, e.length, a)],
        linked: (t, n) => {
          const r = c(t)(f);
          return d(n) ? ((a = n), e.modifiers ? e.modifiers[a] : X)(r) : r;
          var a;
        },
        message: c,
        type: v(e.processor) && d(e.processor.type) ? e.processor.type : "text",
        interpolate: u,
        normalize: i,
      };
    return f;
  }
  function Z(e, t, n) {
    return [
      ...new Set([n, ...(p(t) ? t : b(t) ? Object.keys(t) : d(t) ? [t] : [n])]),
    ];
  }
  function ee(e, t, n) {
    const r = d(n) ? n : ae,
      a = e;
    a.__localeChainCache || (a.__localeChainCache = new Map());
    let o = a.__localeChainCache.get(r);
    if (!o) {
      o = [];
      let e = [n];
      for (; p(e); ) e = te(o, e, t);
      const s = p(t) || !v(t) ? t : t.default ? t.default : null;
      (e = d(s) ? [s] : s),
        p(e) && te(o, e, !1),
        a.__localeChainCache.set(r, o);
    }
    return o;
  }
  function te(e, t, n) {
    let r = !0;
    for (let a = 0; a < t.length && _(r); a++) {
      const o = t[a];
      d(o) && (r = ne(e, t[a], n));
    }
    return r;
  }
  function ne(e, t, n) {
    let r;
    const a = t.split("-");
    do {
      (r = re(e, a.join("-"), n)), a.splice(-1, 1);
    } while (a.length && !0 === r);
    return r;
  }
  function re(e, t, n) {
    let r = !1;
    if (!e.includes(t) && ((r = !0), t)) {
      r = "!" !== t[t.length - 1];
      const a = t.replace(/!/g, "");
      e.push(a), (p(n) || v(n)) && n[a] && (r = n[a]);
    }
    return r;
  }
  const ae = "en-US";
  let oe, se, le;
  let ce = 0;
  function ie(e = {}) {
    const t = d(e.version) ? e.version : "9.2.0-beta.26",
      n = d(e.locale) ? e.locale : ae,
      r =
        p(e.fallbackLocale) ||
        v(e.fallbackLocale) ||
        d(e.fallbackLocale) ||
        !1 === e.fallbackLocale
          ? e.fallbackLocale
          : n,
      a = v(e.messages) ? e.messages : { [n]: {} },
      o = v(e.datetimeFormats) ? e.datetimeFormats : { [n]: {} },
      l = v(e.numberFormats) ? e.numberFormats : { [n]: {} },
      u = i({}, e.modifiers || {}, {
        upper: (e) => (d(e) ? e.toUpperCase() : e),
        lower: (e) => (d(e) ? e.toLowerCase() : e),
        capitalize: (e) =>
          d(e) ? `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}` : e,
      }),
      f = e.pluralRules || {},
      m = g(e.missing) ? e.missing : null,
      h = (!_(e.missingWarn) && !s(e.missingWarn)) || e.missingWarn,
      k = (!_(e.fallbackWarn) && !s(e.fallbackWarn)) || e.fallbackWarn,
      y = !!e.fallbackFormat,
      L = !!e.unresolving,
      T = g(e.postTranslation) ? e.postTranslation : null,
      E = v(e.processor) ? e.processor : null,
      F = !_(e.warnHtmlMessage) || e.warnHtmlMessage,
      N = !!e.escapeParameter,
      I = g(e.messageCompiler) ? e.messageCompiler : oe,
      R = g(e.messageResolver) ? e.messageResolver : se || J,
      O = g(e.localeFallbacker) ? e.localeFallbacker : le || Z,
      C = g(e.onWarn) ? e.onWarn : c,
      P = e,
      w = b(P.__datetimeFormatters) ? P.__datetimeFormatters : new Map(),
      M = b(P.__numberFormatters) ? P.__numberFormatters : new Map(),
      W = b(P.__meta) ? P.__meta : {};
    ce++;
    const S = {
      version: t,
      cid: ce,
      locale: n,
      fallbackLocale: r,
      messages: a,
      modifiers: u,
      pluralRules: f,
      missing: m,
      missingWarn: h,
      fallbackWarn: k,
      fallbackFormat: y,
      unresolving: L,
      postTranslation: T,
      processor: E,
      warnHtmlMessage: F,
      escapeParameter: N,
      messageCompiler: I,
      messageResolver: R,
      localeFallbacker: O,
      onWarn: C,
      __meta: W,
    };
    return (
      (S.datetimeFormats = o),
      (S.numberFormats = l),
      (S.__datetimeFormatters = w),
      (S.__numberFormatters = M),
      S
    );
  }
  function ue(e, t, n, r, a) {
    const { missing: o, onWarn: s } = e;
    if (null !== o) {
      const r = o(e, n, t, a);
      return d(r) ? r : t;
    }
    return t;
  }
  function fe(e, t, n) {
    (e.__localeChainCache = new Map()), e.localeFallbacker(e, n, t);
  }
  const me = (e) => e;
  let pe = Object.create(null);
  let ge = y;
  const de = () => ++ge,
    _e = {
      INVALID_ARGUMENT: ge,
      INVALID_DATE_ARGUMENT: de(),
      INVALID_ISO_DATE_ARGUMENT: de(),
      __EXTEND_POINT__: de(),
    },
    be = () => "",
    he = (e) => g(e);
  function ke(e, ...t) {
    const {
        fallbackFormat: n,
        postTranslation: r,
        unresolving: a,
        messageCompiler: s,
        fallbackLocale: l,
        messages: c,
      } = e,
      [i, f] = ye(...t),
      m =
        (_(f.missingWarn) ? f.missingWarn : e.missingWarn,
        _(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn,
        _(f.escapeParameter) ? f.escapeParameter : e.escapeParameter),
      h = !!f.resolvedMessage,
      k =
        d(f.default) || _(f.default)
          ? _(f.default)
            ? i
            : f.default
          : n
          ? s
            ? i
            : () => i
          : "",
      v = n || "" !== k,
      y = d(f.locale) ? f.locale : e.locale;
    m &&
      (function (e) {
        p(e.list)
          ? (e.list = e.list.map((e) => (d(e) ? u(e) : e)))
          : b(e.named) &&
            Object.keys(e.named).forEach((t) => {
              d(e.named[t]) && (e.named[t] = u(e.named[t]));
            });
      })(f);
    let [L, T, E] = h
        ? [i, y, c[y] || {}]
        : (function (e, t, n, r, a, o) {
            const {
                messages: s,
                onWarn: l,
                messageResolver: c,
                localeFallbacker: i,
              } = e,
              u = i(e, r, n);
            let f,
              m = {},
              p = null;
            const _ = "translate";
            for (
              let n = 0;
              n < u.length &&
              ((f = u[n]),
              (m = s[f] || {}),
              null === (p = c(m, t)) && (p = m[t]),
              !d(p) && !g(p));
              n++
            ) {
              const n = ue(e, t, f, 0, _);
              n !== t && (p = n);
            }
            return [p, f, m];
          })(e, i, y, l),
      F = L,
      N = i;
    if (
      (h || d(F) || he(F) || (v && ((F = k), (N = F))),
      !(h || ((d(F) || he(F)) && d(T))))
    )
      return a ? -1 : i;
    let I = !1;
    const R = he(F)
      ? F
      : ve(e, i, T, F, N, () => {
          I = !0;
        });
    if (I) return F;
    const O = (function (e, t, n, r) {
        const { modifiers: a, pluralRules: s, messageResolver: l } = e,
          c = (r) => {
            const a = l(n, r);
            if (d(a)) {
              let n = !1;
              const o = ve(e, r, t, a, r, () => {
                n = !0;
              });
              return n ? be : o;
            }
            return he(a) ? a : be;
          },
          i = { locale: t, modifiers: a, pluralRules: s, messages: c };
        e.processor && (i.processor = e.processor);
        r.list && (i.list = r.list);
        r.named && (i.named = r.named);
        o(r.plural) && (i.pluralIndex = r.plural);
        return i;
      })(e, T, E, f),
      C = (function (e, t, n) {
        return t(n);
      })(0, R, Q(O));
    return r ? r(C) : C;
  }
  function ve(e, t, n, r, o, s) {
    const { messageCompiler: l, warnHtmlMessage: c } = e;
    if (he(r)) {
      const e = r;
      return (e.locale = e.locale || n), (e.key = e.key || t), e;
    }
    const i = l(
      r,
      (function (e, t, n, r, o, s) {
        return {
          warnHtmlMessage: o,
          onError: (e) => {
            throw (s && s(e), e);
          },
          onCacheKey: (e) => ((e, t, n) => a({ l: e, k: t, s: n }))(t, n, e),
        };
      })(0, n, o, 0, c, s)
    );
    return (i.locale = n), (i.key = t), (i.source = r), i;
  }
  function ye(...e) {
    const [t, n, r] = e,
      a = {};
    if (!d(t) && !o(t) && !he(t)) throw Error(_e.INVALID_ARGUMENT);
    const s = o(t) ? String(t) : (he(t), t);
    return (
      o(n)
        ? (a.plural = n)
        : d(n)
        ? (a.default = n)
        : v(n) && !l(n)
        ? (a.named = n)
        : p(n) && (a.list = n),
      o(r) ? (a.plural = r) : d(r) ? (a.default = r) : v(r) && i(a, r),
      [s, a]
    );
  }
  function Le(e, ...t) {
    const {
        datetimeFormats: n,
        unresolving: r,
        fallbackLocale: a,
        onWarn: o,
        localeFallbacker: s,
      } = e,
      { __datetimeFormatters: c } = e,
      [u, f, m, p] = Te(...t);
    _(m.missingWarn) ? m.missingWarn : e.missingWarn;
    _(m.fallbackWarn) ? m.fallbackWarn : e.fallbackWarn;
    const g = !!m.part,
      b = d(m.locale) ? m.locale : e.locale,
      h = s(e, a, b);
    if (!d(u) || "" === u) return new Intl.DateTimeFormat(b).format(f);
    let k,
      y = {},
      L = null;
    for (
      let t = 0;
      t < h.length && ((k = h[t]), (y = n[k] || {}), (L = y[u]), !v(L));
      t++
    )
      ue(e, u, k, 0, "datetime format");
    if (!v(L) || !d(k)) return r ? -1 : u;
    let T = `${k}__${u}`;
    l(p) || (T = `${T}__${JSON.stringify(p)}`);
    let E = c.get(T);
    return (
      E || ((E = new Intl.DateTimeFormat(k, i({}, L, p))), c.set(T, E)),
      g ? E.formatToParts(f) : E.format(f)
    );
  }
  function Te(...e) {
    const [t, n, r, a] = e;
    let s,
      l = {},
      c = {};
    if (d(t)) {
      const e = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
      if (!e) throw Error(_e.INVALID_ISO_DATE_ARGUMENT);
      const n = e[3]
        ? e[3].trim().startsWith("T")
          ? `${e[1].trim()}${e[3].trim()}`
          : `${e[1].trim()}T${e[3].trim()}`
        : e[1].trim();
      s = new Date(n);
      try {
        s.toISOString();
      } catch (e) {
        throw Error(_e.INVALID_ISO_DATE_ARGUMENT);
      }
    } else if ("[object Date]" === k(t)) {
      if (isNaN(t.getTime())) throw Error(_e.INVALID_DATE_ARGUMENT);
      s = t;
    } else {
      if (!o(t)) throw Error(_e.INVALID_ARGUMENT);
      s = t;
    }
    return (
      d(n) ? (l.key = n) : v(n) && (l = n),
      d(r) ? (l.locale = r) : v(r) && (c = r),
      v(a) && (c = a),
      [l.key || "", s, l, c]
    );
  }
  function Ee(e, t, n) {
    const r = e;
    for (const e in n) {
      const n = `${t}__${e}`;
      r.__datetimeFormatters.has(n) && r.__datetimeFormatters.delete(n);
    }
  }
  function Fe(e, ...t) {
    const {
        numberFormats: n,
        unresolving: r,
        fallbackLocale: a,
        onWarn: o,
        localeFallbacker: s,
      } = e,
      { __numberFormatters: c } = e,
      [u, f, m, p] = Ne(...t);
    _(m.missingWarn) ? m.missingWarn : e.missingWarn;
    _(m.fallbackWarn) ? m.fallbackWarn : e.fallbackWarn;
    const g = !!m.part,
      b = d(m.locale) ? m.locale : e.locale,
      h = s(e, a, b);
    if (!d(u) || "" === u) return new Intl.NumberFormat(b).format(f);
    let k,
      y = {},
      L = null;
    for (
      let t = 0;
      t < h.length && ((k = h[t]), (y = n[k] || {}), (L = y[u]), !v(L));
      t++
    )
      ue(e, u, k, 0, "number format");
    if (!v(L) || !d(k)) return r ? -1 : u;
    let T = `${k}__${u}`;
    l(p) || (T = `${T}__${JSON.stringify(p)}`);
    let E = c.get(T);
    return (
      E || ((E = new Intl.NumberFormat(k, i({}, L, p))), c.set(T, E)),
      g ? E.formatToParts(f) : E.format(f)
    );
  }
  function Ne(...e) {
    const [t, n, r, a] = e;
    let s = {},
      l = {};
    if (!o(t)) throw Error(_e.INVALID_ARGUMENT);
    const c = t;
    return (
      d(n) ? (s.key = n) : v(n) && (s = n),
      d(r) ? (s.locale = r) : v(r) && (l = r),
      v(a) && (l = a),
      [s.key || "", c, s, l]
    );
  }
  function Ie(e, t, n) {
    const r = e;
    for (const e in n) {
      const n = `${t}__${e}`;
      r.__numberFormatters.has(n) && r.__numberFormatters.delete(n);
    }
  }
  const Re = "9.2.0-beta.26";
  let Oe = y;
  const Ce = () => ++Oe,
    Pe = {
      UNEXPECTED_RETURN_TYPE: Oe,
      INVALID_ARGUMENT: Ce(),
      MUST_BE_CALL_SETUP_TOP: Ce(),
      NOT_INSLALLED: Ce(),
      NOT_AVAILABLE_IN_LEGACY_MODE: Ce(),
      REQUIRED_VALUE: Ce(),
      INVALID_VALUE: Ce(),
      CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: Ce(),
      NOT_INSLALLED_WITH_PROVIDE: Ce(),
      UNEXPECTED_ERROR: Ce(),
      NOT_COMPATIBLE_LEGACY_VUE_I18N: Ce(),
      BRIDGE_SUPPORT_VUE_2_ONLY: Ce(),
      __EXTEND_POINT__: Ce(),
    };
  const we = r("__transrateVNode"),
    Me = r("__datetimeParts"),
    We = r("__numberParts"),
    Se = r("__setPluralRules"),
    xe = r("__injectWithOption");
  function De(e) {
    if (!b(e)) return e;
    for (const t in e)
      if (m(e, t))
        if (t.includes(".")) {
          const n = t.split("."),
            r = n.length - 1;
          let a = e;
          for (let e = 0; e < r; e++)
            n[e] in a || (a[n[e]] = {}), (a = a[n[e]]);
          (a[n[r]] = e[t]), delete e[t], b(a[n[r]]) && De(a[n[r]]);
        } else b(e[t]) && De(e[t]);
    return e;
  }
  function $e(e, t) {
    const { messages: n, __i18n: r, messageResolver: a, flatJson: o } = t,
      s = v(n) ? n : p(r) ? {} : { [e]: {} };
    if (
      (p(r) &&
        r.forEach((e) => {
          if ("locale" in e && "resource" in e) {
            const { locale: t, resource: n } = e;
            t ? ((s[t] = s[t] || {}), Ue(n, s[t])) : Ue(n, s);
          } else d(e) && Ue(JSON.parse(e), s);
        }),
      null == a && o)
    )
      for (const e in s) m(s, e) && De(s[e]);
    return s;
  }
  const Ae = (e) => !b(e) || p(e);
  function Ue(e, t) {
    if (Ae(e) || Ae(t)) throw Error(Pe.INVALID_VALUE);
    for (const n in e)
      m(e, n) && (Ae(e[n]) || Ae(t[n]) ? (t[n] = e[n]) : Ue(e[n], t[n]));
  }
  function je(e, t, n) {
    let r = b(t.messages) ? t.messages : {};
    "__i18nGlobal" in n &&
      (r = $e(e.locale.value, { messages: r, __i18n: n.__i18nGlobal }));
    const a = Object.keys(r);
    if (
      (a.length &&
        a.forEach((t) => {
          e.mergeLocaleMessage(t, r[t]);
        }),
      b(t.datetimeFormats))
    ) {
      const n = Object.keys(t.datetimeFormats);
      n.length &&
        n.forEach((n) => {
          e.mergeDateTimeFormat(n, t.datetimeFormats[n]);
        });
    }
    if (b(t.numberFormats)) {
      const n = Object.keys(t.numberFormats);
      n.length &&
        n.forEach((n) => {
          e.mergeNumberFormat(n, t.numberFormats[n]);
        });
    }
  }
  function He(e) {
    return t.createVNode(t.Text, null, e, 0);
  }
  let Ve = 0;
  function Ge(e) {
    return (n, r, a, o) => e(r, a, t.getCurrentInstance() || void 0, o);
  }
  function ze(e = {}, n) {
    const { __root: r } = e,
      a = void 0 === r;
    let l = !_(e.inheritLocale) || e.inheritLocale;
    const c = t.ref(r && l ? r.locale.value : d(e.locale) ? e.locale : ae),
      u = t.ref(
        r && l
          ? r.fallbackLocale.value
          : d(e.fallbackLocale) ||
            p(e.fallbackLocale) ||
            v(e.fallbackLocale) ||
            !1 === e.fallbackLocale
          ? e.fallbackLocale
          : c.value
      ),
      f = t.ref($e(c.value, e)),
      m = t.ref(v(e.datetimeFormats) ? e.datetimeFormats : { [c.value]: {} }),
      h = t.ref(v(e.numberFormats) ? e.numberFormats : { [c.value]: {} });
    let k = r
        ? r.missingWarn
        : (!_(e.missingWarn) && !s(e.missingWarn)) || e.missingWarn,
      y = r
        ? r.fallbackWarn
        : (!_(e.fallbackWarn) && !s(e.fallbackWarn)) || e.fallbackWarn,
      L = r ? r.fallbackRoot : !_(e.fallbackRoot) || e.fallbackRoot,
      T = !!e.fallbackFormat,
      E = g(e.missing) ? e.missing : null,
      F = g(e.missing) ? Ge(e.missing) : null,
      N = g(e.postTranslation) ? e.postTranslation : null,
      I = r ? r.warnHtmlMessage : !_(e.warnHtmlMessage) || e.warnHtmlMessage,
      R = !!e.escapeParameter;
    const O = r ? r.modifiers : v(e.modifiers) ? e.modifiers : {};
    let C,
      P = e.pluralRules || (r && r.pluralRules);
    (C = (function () {
      const t = {
        version: Re,
        locale: c.value,
        fallbackLocale: u.value,
        messages: f.value,
        modifiers: O,
        pluralRules: P,
        missing: null === F ? void 0 : F,
        missingWarn: k,
        fallbackWarn: y,
        fallbackFormat: T,
        unresolving: !0,
        postTranslation: null === N ? void 0 : N,
        warnHtmlMessage: I,
        escapeParameter: R,
        messageResolver: e.messageResolver,
        __meta: { framework: "vue" },
      };
      return (
        (t.datetimeFormats = m.value),
        (t.numberFormats = h.value),
        (t.__datetimeFormatters = v(C) ? C.__datetimeFormatters : void 0),
        (t.__numberFormatters = v(C) ? C.__numberFormatters : void 0),
        ie(t)
      );
    })()),
      fe(C, c.value, u.value);
    const w = t.computed({
        get: () => c.value,
        set: (e) => {
          (c.value = e), (C.locale = c.value);
        },
      }),
      M = t.computed({
        get: () => u.value,
        set: (e) => {
          (u.value = e), (C.fallbackLocale = u.value), fe(C, c.value, e);
        },
      }),
      W = t.computed(() => f.value),
      S = t.computed(() => m.value),
      x = t.computed(() => h.value);
    function D(e, t, n, a, s, l) {
      let i;
      if (
        (c.value,
        u.value,
        f.value,
        m.value,
        h.value,
        (i = e(C)),
        o(i) && -1 === i)
      ) {
        const [e, n] = t();
        return r && L ? a(r) : s(e);
      }
      if (l(i)) return i;
      throw Error(Pe.UNEXPECTED_RETURN_TYPE);
    }
    function $(...e) {
      return D(
        (t) => Reflect.apply(ke, null, [t, ...e]),
        () => ye(...e),
        0,
        (t) => Reflect.apply(t.t, t, [...e]),
        (e) => e,
        (e) => d(e)
      );
    }
    const A = {
      normalize: function (e) {
        return e.map((e) => (d(e) ? He(e) : e));
      },
      interpolate: (e) => e,
      type: "vnode",
    };
    function U(e) {
      return f.value[e] || {};
    }
    Ve++,
      r &&
        (t.watch(r.locale, (e) => {
          l && ((c.value = e), (C.locale = e), fe(C, c.value, u.value));
        }),
        t.watch(r.fallbackLocale, (e) => {
          l && ((u.value = e), (C.fallbackLocale = e), fe(C, c.value, u.value));
        }));
    const j = {
      id: Ve,
      locale: w,
      fallbackLocale: M,
      get inheritLocale() {
        return l;
      },
      set inheritLocale(e) {
        (l = e),
          e &&
            r &&
            ((c.value = r.locale.value),
            (u.value = r.fallbackLocale.value),
            fe(C, c.value, u.value));
      },
      get availableLocales() {
        return Object.keys(f.value).sort();
      },
      messages: W,
      get modifiers() {
        return O;
      },
      get pluralRules() {
        return P || {};
      },
      get isGlobal() {
        return a;
      },
      get missingWarn() {
        return k;
      },
      set missingWarn(e) {
        (k = e), (C.missingWarn = k);
      },
      get fallbackWarn() {
        return y;
      },
      set fallbackWarn(e) {
        (y = e), (C.fallbackWarn = y);
      },
      get fallbackRoot() {
        return L;
      },
      set fallbackRoot(e) {
        L = e;
      },
      get fallbackFormat() {
        return T;
      },
      set fallbackFormat(e) {
        (T = e), (C.fallbackFormat = T);
      },
      get warnHtmlMessage() {
        return I;
      },
      set warnHtmlMessage(e) {
        (I = e), (C.warnHtmlMessage = e);
      },
      get escapeParameter() {
        return R;
      },
      set escapeParameter(e) {
        (R = e), (C.escapeParameter = e);
      },
      t: $,
      getLocaleMessage: U,
      setLocaleMessage: function (e, t) {
        (f.value[e] = t), (C.messages = f.value);
      },
      mergeLocaleMessage: function (e, t) {
        (f.value[e] = f.value[e] || {}),
          Ue(t, f.value[e]),
          (C.messages = f.value);
      },
      getPostTranslationHandler: function () {
        return g(N) ? N : null;
      },
      setPostTranslationHandler: function (e) {
        (N = e), (C.postTranslation = e);
      },
      getMissingHandler: function () {
        return E;
      },
      setMissingHandler: function (e) {
        null !== e && (F = Ge(e)), (E = e), (C.missing = F);
      },
      [Se]: function (e) {
        (P = e), (C.pluralRules = P);
      },
    };
    return (
      (j.datetimeFormats = S),
      (j.numberFormats = x),
      (j.rt = function (...e) {
        const [t, n, r] = e;
        if (r && !b(r)) throw Error(Pe.INVALID_ARGUMENT);
        return $(t, n, i({ resolvedMessage: !0 }, r || {}));
      }),
      (j.te = function (e, t) {
        const n = U(d(t) ? t : c.value);
        return null !== C.messageResolver(n, e);
      }),
      (j.tm = function (e) {
        const t = (function (e) {
          let t = null;
          const n = ee(C, u.value, c.value);
          for (let r = 0; r < n.length; r++) {
            const a = f.value[n[r]] || {},
              o = C.messageResolver(a, e);
            if (null != o) {
              t = o;
              break;
            }
          }
          return t;
        })(e);
        return null != t ? t : (r && r.tm(e)) || {};
      }),
      (j.d = function (...e) {
        return D(
          (t) => Reflect.apply(Le, null, [t, ...e]),
          () => Te(...e),
          0,
          (t) => Reflect.apply(t.d, t, [...e]),
          () => "",
          (e) => d(e)
        );
      }),
      (j.n = function (...e) {
        return D(
          (t) => Reflect.apply(Fe, null, [t, ...e]),
          () => Ne(...e),
          0,
          (t) => Reflect.apply(t.n, t, [...e]),
          () => "",
          (e) => d(e)
        );
      }),
      (j.getDateTimeFormat = function (e) {
        return m.value[e] || {};
      }),
      (j.setDateTimeFormat = function (e, t) {
        (m.value[e] = t), (C.datetimeFormats = m.value), Ee(C, e, t);
      }),
      (j.mergeDateTimeFormat = function (e, t) {
        (m.value[e] = i(m.value[e] || {}, t)),
          (C.datetimeFormats = m.value),
          Ee(C, e, t);
      }),
      (j.getNumberFormat = function (e) {
        return h.value[e] || {};
      }),
      (j.setNumberFormat = function (e, t) {
        (h.value[e] = t), (C.numberFormats = h.value), Ie(C, e, t);
      }),
      (j.mergeNumberFormat = function (e, t) {
        (h.value[e] = i(h.value[e] || {}, t)),
          (C.numberFormats = h.value),
          Ie(C, e, t);
      }),
      (j[xe] = e.__injectWithOption),
      (j[we] = function (...e) {
        return D(
          (t) => {
            let n;
            const r = t;
            try {
              (r.processor = A), (n = Reflect.apply(ke, null, [r, ...e]));
            } finally {
              r.processor = null;
            }
            return n;
          },
          () => ye(...e),
          0,
          (t) => t[we](...e),
          (e) => [He(e)],
          (e) => p(e)
        );
      }),
      (j[Me] = function (...e) {
        return D(
          (t) => Reflect.apply(Le, null, [t, ...e]),
          () => Te(...e),
          0,
          (t) => t[Me](...e),
          () => [],
          (e) => d(e) || p(e)
        );
      }),
      (j[We] = function (...e) {
        return D(
          (t) => Reflect.apply(Fe, null, [t, ...e]),
          () => Ne(...e),
          0,
          (t) => t[We](...e),
          () => [],
          (e) => d(e) || p(e)
        );
      }),
      j
    );
  }
  function Je(e = {}, t) {
    {
      const t = ze(
          (function (e) {
            const t = d(e.locale) ? e.locale : ae,
              n =
                d(e.fallbackLocale) ||
                p(e.fallbackLocale) ||
                v(e.fallbackLocale) ||
                !1 === e.fallbackLocale
                  ? e.fallbackLocale
                  : t,
              r = g(e.missing) ? e.missing : void 0,
              a =
                (!_(e.silentTranslationWarn) && !s(e.silentTranslationWarn)) ||
                !e.silentTranslationWarn,
              o =
                (!_(e.silentFallbackWarn) && !s(e.silentFallbackWarn)) ||
                !e.silentFallbackWarn,
              l = !_(e.fallbackRoot) || e.fallbackRoot,
              c = !!e.formatFallbackMessages,
              u = v(e.modifiers) ? e.modifiers : {},
              f = e.pluralizationRules,
              m = g(e.postTranslation) ? e.postTranslation : void 0,
              b = !d(e.warnHtmlInMessage) || "off" !== e.warnHtmlInMessage,
              h = !!e.escapeParameterHtml,
              k = !_(e.sync) || e.sync;
            let y = e.messages;
            if (v(e.sharedMessages)) {
              const t = e.sharedMessages;
              y = Object.keys(t).reduce((e, n) => {
                const r = e[n] || (e[n] = {});
                return i(r, t[n]), e;
              }, y || {});
            }
            const { __i18n: L, __root: T, __injectWithOption: E } = e,
              F = e.datetimeFormats,
              N = e.numberFormats;
            return {
              locale: t,
              fallbackLocale: n,
              messages: y,
              flatJson: e.flatJson,
              datetimeFormats: F,
              numberFormats: N,
              missing: r,
              missingWarn: a,
              fallbackWarn: o,
              fallbackRoot: l,
              fallbackFormat: c,
              modifiers: u,
              pluralRules: f,
              postTranslation: m,
              warnHtmlMessage: b,
              escapeParameter: h,
              messageResolver: e.messageResolver,
              inheritLocale: k,
              __i18n: L,
              __root: T,
              __injectWithOption: E,
            };
          })(e)
        ),
        n = {
          id: t.id,
          get locale() {
            return t.locale.value;
          },
          set locale(e) {
            t.locale.value = e;
          },
          get fallbackLocale() {
            return t.fallbackLocale.value;
          },
          set fallbackLocale(e) {
            t.fallbackLocale.value = e;
          },
          get messages() {
            return t.messages.value;
          },
          get datetimeFormats() {
            return t.datetimeFormats.value;
          },
          get numberFormats() {
            return t.numberFormats.value;
          },
          get availableLocales() {
            return t.availableLocales;
          },
          get formatter() {
            return { interpolate: () => [] };
          },
          set formatter(e) {},
          get missing() {
            return t.getMissingHandler();
          },
          set missing(e) {
            t.setMissingHandler(e);
          },
          get silentTranslationWarn() {
            return _(t.missingWarn) ? !t.missingWarn : t.missingWarn;
          },
          set silentTranslationWarn(e) {
            t.missingWarn = _(e) ? !e : e;
          },
          get silentFallbackWarn() {
            return _(t.fallbackWarn) ? !t.fallbackWarn : t.fallbackWarn;
          },
          set silentFallbackWarn(e) {
            t.fallbackWarn = _(e) ? !e : e;
          },
          get modifiers() {
            return t.modifiers;
          },
          get formatFallbackMessages() {
            return t.fallbackFormat;
          },
          set formatFallbackMessages(e) {
            t.fallbackFormat = e;
          },
          get postTranslation() {
            return t.getPostTranslationHandler();
          },
          set postTranslation(e) {
            t.setPostTranslationHandler(e);
          },
          get sync() {
            return t.inheritLocale;
          },
          set sync(e) {
            t.inheritLocale = e;
          },
          get warnHtmlInMessage() {
            return t.warnHtmlMessage ? "warn" : "off";
          },
          set warnHtmlInMessage(e) {
            t.warnHtmlMessage = "off" !== e;
          },
          get escapeParameterHtml() {
            return t.escapeParameter;
          },
          set escapeParameterHtml(e) {
            t.escapeParameter = e;
          },
          get preserveDirectiveContent() {
            return !0;
          },
          set preserveDirectiveContent(e) {},
          get pluralizationRules() {
            return t.pluralRules || {};
          },
          __composer: t,
          t(...e) {
            const [n, r, a] = e,
              o = {};
            let s = null,
              l = null;
            if (!d(n)) throw Error(Pe.INVALID_ARGUMENT);
            const c = n;
            return (
              d(r) ? (o.locale = r) : p(r) ? (s = r) : v(r) && (l = r),
              p(a) ? (s = a) : v(a) && (l = a),
              Reflect.apply(t.t, t, [c, s || l || {}, o])
            );
          },
          rt: (...e) => Reflect.apply(t.rt, t, [...e]),
          tc(...e) {
            const [n, r, a] = e,
              s = { plural: 1 };
            let l = null,
              c = null;
            if (!d(n)) throw Error(Pe.INVALID_ARGUMENT);
            const i = n;
            return (
              d(r)
                ? (s.locale = r)
                : o(r)
                ? (s.plural = r)
                : p(r)
                ? (l = r)
                : v(r) && (c = r),
              d(a) ? (s.locale = a) : p(a) ? (l = a) : v(a) && (c = a),
              Reflect.apply(t.t, t, [i, l || c || {}, s])
            );
          },
          te: (e, n) => t.te(e, n),
          tm: (e) => t.tm(e),
          getLocaleMessage: (e) => t.getLocaleMessage(e),
          setLocaleMessage(e, n) {
            t.setLocaleMessage(e, n);
          },
          mergeLocaleMessage(e, n) {
            t.mergeLocaleMessage(e, n);
          },
          d: (...e) => Reflect.apply(t.d, t, [...e]),
          getDateTimeFormat: (e) => t.getDateTimeFormat(e),
          setDateTimeFormat(e, n) {
            t.setDateTimeFormat(e, n);
          },
          mergeDateTimeFormat(e, n) {
            t.mergeDateTimeFormat(e, n);
          },
          n: (...e) => Reflect.apply(t.n, t, [...e]),
          getNumberFormat: (e) => t.getNumberFormat(e),
          setNumberFormat(e, n) {
            t.setNumberFormat(e, n);
          },
          mergeNumberFormat(e, n) {
            t.mergeNumberFormat(e, n);
          },
          getChoiceIndex: (e, t) => -1,
          __onComponentInstanceCreated(t) {
            const { componentInstanceCreatedListener: r } = e;
            r && r(t, n);
          },
        };
      return n;
    }
  }
  const Xe = {
    tag: { type: [String, Object] },
    locale: { type: String },
    scope: {
      type: String,
      validator: (e) => "parent" === e || "global" === e,
      default: "parent",
    },
    i18n: { type: Object },
  };
  function Be(e) {
    return t.Fragment;
  }
  const Ye = {
    name: "i18n-t",
    props: i(
      {
        keypath: { type: String, required: !0 },
        plural: { type: [Number, String], validator: (e) => o(e) || !isNaN(e) },
      },
      Xe
    ),
    setup(e, n) {
      const { slots: r, attrs: a } = n,
        o = e.i18n || ot({ useScope: e.scope, __useComponent: !0 }),
        s = Object.keys(r).filter((e) => "_" !== e);
      return () => {
        const r = {};
        e.locale && (r.locale = e.locale),
          void 0 !== e.plural &&
            (r.plural = d(e.plural) ? +e.plural : e.plural);
        const l = (function ({ slots: e }, t) {
            if (1 === t.length && "default" === t[0])
              return (e.default ? e.default() : []).reduce(
                (e, t) => [...e, ...(p(t.children) ? t.children : [t])],
                []
              );
            return t.reduce((t, n) => {
              const r = e[n];
              return r && (t[n] = r()), t;
            }, {});
          })(n, s),
          c = o[we](e.keypath, l, r),
          u = i({}, a),
          f = d(e.tag) || b(e.tag) ? e.tag : Be();
        return t.h(f, u, c);
      };
    },
  };
  function qe(e, n, r, a) {
    const { slots: o, attrs: s } = n;
    return () => {
      const n = { part: !0 };
      let l = {};
      e.locale && (n.locale = e.locale),
        d(e.format)
          ? (n.key = e.format)
          : b(e.format) &&
            (d(e.format.key) && (n.key = e.format.key),
            (l = Object.keys(e.format).reduce(
              (t, n) => (r.includes(n) ? i({}, t, { [n]: e.format[n] }) : t),
              {}
            )));
      const c = a(e.value, n, l);
      let u = [n.key];
      p(c)
        ? (u = c.map((e, t) => {
            const n = o[e.type];
            return n ? n({ [e.type]: e.value, index: t, parts: c }) : [e.value];
          }))
        : d(c) && (u = [c]);
      const f = i({}, s),
        m = d(e.tag) || b(e.tag) ? e.tag : Be();
      return t.h(m, f, u);
    };
  }
  const Ke = [
      "localeMatcher",
      "style",
      "unit",
      "unitDisplay",
      "currency",
      "currencyDisplay",
      "useGrouping",
      "numberingSystem",
      "minimumIntegerDigits",
      "minimumFractionDigits",
      "maximumFractionDigits",
      "minimumSignificantDigits",
      "maximumSignificantDigits",
      "notation",
      "formatMatcher",
    ],
    Qe = {
      name: "i18n-n",
      props: i(
        {
          value: { type: Number, required: !0 },
          format: { type: [String, Object] },
        },
        Xe
      ),
      setup(e, t) {
        const n = e.i18n || ot({ useScope: "parent", __useComponent: !0 });
        return qe(e, t, Ke, (...e) => n[We](...e));
      },
    },
    Ze = [
      "dateStyle",
      "timeStyle",
      "fractionalSecondDigits",
      "calendar",
      "dayPeriod",
      "numberingSystem",
      "localeMatcher",
      "timeZone",
      "hour12",
      "hourCycle",
      "formatMatcher",
      "weekday",
      "era",
      "year",
      "month",
      "day",
      "hour",
      "minute",
      "second",
      "timeZoneName",
    ],
    et = {
      name: "i18n-d",
      props: i(
        {
          value: { type: [Number, Date], required: !0 },
          format: { type: [String, Object] },
        },
        Xe
      ),
      setup(e, t) {
        const n = e.i18n || ot({ useScope: "parent", __useComponent: !0 });
        return qe(e, t, Ze, (...e) => n[Me](...e));
      },
    };
  function tt(e) {
    const t = (t, { instance: n, value: r, modifiers: a }) => {
      if (!n || !n.$) throw Error(Pe.UNEXPECTED_ERROR);
      const o = (function (e, t) {
          const n = e;
          if ("composition" === e.mode) return n.__getInstance(t) || e.global;
          {
            const r = n.__getInstance(t);
            return null != r ? r.__composer : e.global.__composer;
          }
        })(e, n.$),
        s = (function (e) {
          if (d(e)) return { path: e };
          if (v(e)) {
            if (!("path" in e)) throw Error(Pe.REQUIRED_VALUE, "path");
            return e;
          }
          throw Error(Pe.INVALID_VALUE);
        })(r);
      t.textContent = Reflect.apply(o.t, o, [...nt(s)]);
    };
    return { beforeMount: t, beforeUpdate: t };
  }
  function nt(e) {
    const { path: t, locale: n, args: r, choice: a, plural: s } = e,
      l = {},
      c = r || {};
    return (
      d(n) && (l.locale = n),
      o(a) && (l.plural = a),
      o(s) && (l.plural = s),
      [t, c, l]
    );
  }
  function rt(e, t) {
    (e.locale = t.locale || e.locale),
      (e.fallbackLocale = t.fallbackLocale || e.fallbackLocale),
      (e.missing = t.missing || e.missing),
      (e.silentTranslationWarn =
        t.silentTranslationWarn || e.silentFallbackWarn),
      (e.silentFallbackWarn = t.silentFallbackWarn || e.silentFallbackWarn),
      (e.formatFallbackMessages =
        t.formatFallbackMessages || e.formatFallbackMessages),
      (e.postTranslation = t.postTranslation || e.postTranslation),
      (e.warnHtmlInMessage = t.warnHtmlInMessage || e.warnHtmlInMessage),
      (e.escapeParameterHtml = t.escapeParameterHtml || e.escapeParameterHtml),
      (e.sync = t.sync || e.sync),
      e.__composer[Se](t.pluralizationRules || e.pluralizationRules);
    const n = $e(e.locale, { messages: t.messages, __i18n: t.__i18n });
    return (
      Object.keys(n).forEach((t) => e.mergeLocaleMessage(t, n[t])),
      t.datetimeFormats &&
        Object.keys(t.datetimeFormats).forEach((n) =>
          e.mergeDateTimeFormat(n, t.datetimeFormats[n])
        ),
      t.numberFormats &&
        Object.keys(t.numberFormats).forEach((n) =>
          e.mergeNumberFormat(n, t.numberFormats[n])
        ),
      e
    );
  }
  const at = r("global-vue-i18n");
  function ot(e = {}) {
    const n = t.getCurrentInstance();
    if (null == n) throw Error(Pe.MUST_BE_CALL_SETUP_TOP);
    if (
      !n.isCE &&
      null != n.appContext.app &&
      !n.appContext.app.__VUE_I18N_SYMBOL__
    )
      throw Error(Pe.NOT_INSLALLED);
    const r = (function (e) {
        {
          const n = t.inject(
            e.isCE ? at : e.appContext.app.__VUE_I18N_SYMBOL__
          );
          if (!n)
            throw (function (e, ...t) {
              return L(e, null, void 0);
            })(e.isCE ? Pe.NOT_INSLALLED_WITH_PROVIDE : Pe.UNEXPECTED_ERROR);
          return n;
        }
      })(n),
      a = (function (e) {
        return "composition" === e.mode ? e.global : e.global.__composer;
      })(r),
      o = (function (e) {
        return e.type;
      })(n),
      s = (function (e, t) {
        return l(e)
          ? "__i18n" in t
            ? "local"
            : "global"
          : e.useScope
          ? e.useScope
          : "local";
      })(e, o);
    if ("global" === s) return je(a, e, o), a;
    if ("parent" === s) {
      let t = (function (e, t, n = !1) {
        let r = null;
        const a = t.root;
        let o = t.parent;
        for (; null != o; ) {
          const t = e;
          if ("composition" === e.mode) r = t.__getInstance(o);
          else {
            const e = t.__getInstance(o);
            null != e && ((r = e.__composer), n && r && !r[xe] && (r = null));
          }
          if (null != r) break;
          if (a === o) break;
          o = o.parent;
        }
        return r;
      })(r, n, e.__useComponent);
      return null == t && (t = a), t;
    }
    if ("legacy" === r.mode) throw Error(Pe.NOT_AVAILABLE_IN_LEGACY_MODE);
    const c = r;
    let u = c.__getInstance(n);
    if (null == u) {
      const r = i({}, e);
      "__i18n" in o && (r.__i18n = o.__i18n),
        a && (r.__root = a),
        (u = ze(r)),
        (function (e, n, r) {
          t.onMounted(() => {}, n),
            t.onUnmounted(() => {
              e.__deleteInstance(n);
            }, n);
        })(c, n),
        c.__setInstance(n, u);
    }
    return u;
  }
  const st = ["locale", "fallbackLocale", "availableLocales"],
    lt = ["t", "rt", "d", "n", "tm"];
  var ct;
  return (
    (ct = function (e, t = {}) {
      {
        const n = (t.onCacheKey || me)(e),
          r = pe[n];
        if (r) return r;
        let a = !1;
        const o = t.onError || T;
        t.onError = (e) => {
          (a = !0), o(e);
        };
        const { code: s } = U(e, t),
          l = new Function(`return ${s}`)();
        return a ? l : (pe[n] = l);
      }
    }),
    (oe = ct),
    (se = function (e, t) {
      if (!b(e)) return null;
      let n = z.get(t);
      if (
        (n ||
          ((n = (function (e) {
            const t = [];
            let n,
              r,
              a,
              o,
              s,
              l,
              c,
              i = -1,
              u = 0,
              f = 0;
            const m = [];
            function p() {
              const t = e[i + 1];
              if ((5 === u && "'" === t) || (6 === u && '"' === t))
                return i++, (a = "\\" + t), m[0](), !0;
            }
            for (
              m[0] = () => {
                void 0 === r ? (r = a) : (r += a);
              },
                m[1] = () => {
                  void 0 !== r && (t.push(r), (r = void 0));
                },
                m[2] = () => {
                  m[0](), f++;
                },
                m[3] = () => {
                  if (f > 0) f--, (u = 4), m[0]();
                  else {
                    if (((f = 0), void 0 === r)) return !1;
                    if (((r = G(r)), !1 === r)) return !1;
                    m[1]();
                  }
                };
              null !== u;

            )
              if ((i++, (n = e[i]), "\\" !== n || !p())) {
                if (((o = V(n)), (c = j[u]), (s = c[o] || c.l || 8), 8 === s))
                  return;
                if (
                  ((u = s[0]),
                  void 0 !== s[1] &&
                    ((l = m[s[1]]), l && ((a = n), !1 === l())))
                )
                  return;
                if (7 === u) return t;
              }
          })(t)),
          n && z.set(t, n)),
        !n)
      )
        return null;
      const r = n.length;
      let a = e,
        o = 0;
      for (; o < r; ) {
        const e = a[n[o]];
        if (void 0 === e) return null;
        (a = e), o++;
      }
      return a;
    }),
    (le = ee),
    (e.DatetimeFormat = et),
    (e.I18nInjectionKey = at),
    (e.NumberFormat = Qe),
    (e.Translation = Ye),
    (e.VERSION = Re),
    (e.createI18n = function (e = {}, n) {
      const a = !_(e.legacy) || e.legacy,
        o = !!e.globalInjection,
        s = new Map(),
        l = (function (e, t, n) {
          return t ? Je(e) : ze(e);
        })(e, a),
        c = r("");
      {
        const e = {
          get mode() {
            return a ? "legacy" : "composition";
          },
          async install(n, ...r) {
            (n.__VUE_I18N_SYMBOL__ = c),
              n.provide(n.__VUE_I18N_SYMBOL__, e),
              !a &&
                o &&
                (function (e, n) {
                  const r = Object.create(null);
                  st.forEach((e) => {
                    const a = Object.getOwnPropertyDescriptor(n, e);
                    if (!a) throw Error(Pe.UNEXPECTED_ERROR);
                    const o = t.isRef(a.value)
                      ? {
                          get: () => a.value.value,
                          set(e) {
                            a.value.value = e;
                          },
                        }
                      : { get: () => a.get && a.get() };
                    Object.defineProperty(r, e, o);
                  }),
                    (e.config.globalProperties.$i18n = r),
                    lt.forEach((t) => {
                      const r = Object.getOwnPropertyDescriptor(n, t);
                      if (!r || !r.value) throw Error(Pe.UNEXPECTED_ERROR);
                      Object.defineProperty(
                        e.config.globalProperties,
                        `$${t}`,
                        r
                      );
                    });
                })(n, e.global),
              (function (e, t, ...n) {
                const r = v(n[0]) ? n[0] : {},
                  a = !!r.useI18nComponentName;
                (!_(r.globalInstall) || r.globalInstall) &&
                  (e.component(a ? "i18n" : Ye.name, Ye),
                  e.component(Qe.name, Qe),
                  e.component(et.name, et)),
                  e.directive("t", tt(t));
              })(n, e, ...r),
              a &&
                n.mixin(
                  (function (e, n, r) {
                    return {
                      beforeCreate() {
                        const a = t.getCurrentInstance();
                        if (!a) throw Error(Pe.UNEXPECTED_ERROR);
                        const o = this.$options;
                        if (o.i18n) {
                          const t = o.i18n;
                          o.__i18n && (t.__i18n = o.__i18n),
                            (t.__root = n),
                            this === this.$root
                              ? (this.$i18n = rt(e, t))
                              : ((t.__injectWithOption = !0),
                                (this.$i18n = Je(t)));
                        } else
                          o.__i18n
                            ? this === this.$root
                              ? (this.$i18n = rt(e, o))
                              : (this.$i18n = Je({
                                  __i18n: o.__i18n,
                                  __injectWithOption: !0,
                                  __root: n,
                                }))
                            : (this.$i18n = e);
                        o.__i18nGlobal && je(n, o, o),
                          e.__onComponentInstanceCreated(this.$i18n),
                          r.__setInstance(a, this.$i18n),
                          (this.$t = (...e) => this.$i18n.t(...e)),
                          (this.$rt = (...e) => this.$i18n.rt(...e)),
                          (this.$tc = (...e) => this.$i18n.tc(...e)),
                          (this.$te = (e, t) => this.$i18n.te(e, t)),
                          (this.$d = (...e) => this.$i18n.d(...e)),
                          (this.$n = (...e) => this.$i18n.n(...e)),
                          (this.$tm = (e) => this.$i18n.tm(e));
                      },
                      mounted() {},
                      unmounted() {
                        const e = t.getCurrentInstance();
                        if (!e) throw Error(Pe.UNEXPECTED_ERROR);
                        t.nextTick(() => {
                          delete this.$t,
                            delete this.$rt,
                            delete this.$tc,
                            delete this.$te,
                            delete this.$d,
                            delete this.$n,
                            delete this.$tm,
                            r.__deleteInstance(e),
                            delete this.$i18n;
                        });
                      },
                    };
                  })(l, l.__composer, e)
                );
          },
          get global() {
            return l;
          },
          __instances: s,
          __getInstance: function (e) {
            return s.get(e) || null;
          },
          __setInstance: function (e, t) {
            s.set(e, t);
          },
          __deleteInstance: function (e) {
            s.delete(e);
          },
        };
        return e;
      }
    }),
    (e.useI18n = ot),
    (e.vTDirective = tt),
    Object.defineProperty(e, "__esModule", { value: !0 }),
    e
  );
})({}, Vue);
